import axios from "axios";
import * as Constants from "../constant";
export const getAssets = async (UserId, activePage, filterdId, limit) => {
	try {
		const response = await axios.get(
			`${Constants?.LOCAL_URL}/accountassets/asset/image/${UserId}/${filterdId}/${activePage}/${limit}`
		);
		return response.data;
	} catch (error) {
		return error;
	}
};
